import { render, staticRenderFns } from "./ServiceProviderInvoices.vue?vue&type=template&id=a5b7c694&scoped=true"
import script from "./ServiceProviderInvoices.vue?vue&type=script&lang=js"
export * from "./ServiceProviderInvoices.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderInvoices.vue?vue&type=style&index=0&id=a5b7c694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b7c694",
  null
  
)

export default component.exports